export { CURRENT_SCHEMA_VERSION } from "./schemas/index.js";
export const LEGACY_SCHEMA_VERSION = '1.0.0';
export const CURRENT_API_VERSION = '2';
export const LEGACY_API_VERSION = '1';
